import React from 'react';

const Blockquote = (props) => (
  <section className="blockquote">
    <blockquote>{ props.children }</blockquote>
  </section>
);

export default Blockquote;
